(function () {
  const locale = (
    document.documentElement.lang ||
    window.Shopify?.locale ||
    ''
  ).toLowerCase();

  const pathLocale = window.location.pathname.split('/')[1]?.toLowerCase() || '';
  const pathLanguage = pathLocale.slice(0, 2);
  const language = ['nl', 'de'].includes(pathLanguage) ? pathLanguage : locale.slice(0, 2);

  const translations = {
    nl: ({ rating, count }) =>
      `${count} klanten geven ons ${formatRating(rating, 'nl')}/5`,
    de: ({ rating, count }) =>
      `${count} Kunden geben uns ${formatRating(rating, 'de')}/5`,
  };

  if (!translations[language]) return;

  const counterPatterns = [
    /(?:rated|customers\s+rate\s+us)\s+([0-9]+(?:[.,][0-9]+)?)\/5\s+(?:by|based\s+on)\s+([0-9.,]+)\s+(?:customers|reviews)\.?/i,
    /klanten\s+beoordelen\s+ons\s+met\s+([0-9]+(?:[.,][0-9]+)?)\/5\s+op\s+basis\s+van\s+([0-9.,]+)\s+beoordelingen\.?/i,
    /kunden\s+bewerten\s+uns\s+mit\s+([0-9]+(?:[.,][0-9]+)?)\/5\s+(?:basierend\s+auf|auf\s+grundlage\s+von)\s+([0-9.,]+)\s+(?:bewertungen|rezensionen)\.?/i,
  ];

  function formatRating(rating, lang) {
    const normalized = rating.replace(',', '.');
    return lang === 'de' || lang === 'nl' ? normalized.replace('.', ',') : normalized;
  }

  function findCounterText(text) {
    const normalizedText = text.replace(/\s+/g, ' ');
    const pattern = counterPatterns.find((counterPattern) => counterPattern.test(normalizedText));
    if (!pattern) return null;

    const match = normalizedText.match(pattern);

    return {
      rating: match[1],
      count: match[2],
      pattern,
      original: match[0],
    };
  }

  function translateCounters(root) {
    if (root.nodeType === Node.TEXT_NODE) {
      translateCounterNode(root);
      return;
    }

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(translateCounterNode);
  }

  function translateCounterNode(node) {
    if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(node.parentElement?.tagName)) return;

    const counter = findCounterText(node.textContent);
    if (!counter) return;

    node.textContent = node.textContent.replace(counter.pattern, translations[language](counter));
  }

  function run() {
    translateCounters(document.body);
  }

  document.addEventListener('DOMContentLoaded', run);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        translateCounterNode(mutation.target);
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) {
          translateCounters(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });
})();
